import React from "react";
import SettingsSidebar from "./SettingsSidebar";
import { Outlet } from "react-router-dom";
import '../../Common.css';

const Layout = () => {
    return (
        <div className="settings-layout">
            <div className="row g-0">

                {/* Sidebar */}
                <div className="col-lg-3 col-xl-2">
                    <div className="settings-sidebar-wrapper">
                        <SettingsSidebar />
                    </div>
                </div>

                {/* Content */}
                <div className="col-lg-9 col-xl-10">
                    <div className="settings-content-wrapper">
                        <div className="settings-card">
                            <Outlet />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Layout;